import { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import AssignGroupModal from "./ContactGrouping/AssignGroupModal";
import CreateGroupModal from "./ContactGrouping/CreateGroupModal";
import GroupContactsModal from "./ContactGrouping/GroupContactsModal";
import { useContactGroups } from "../../../context/ContactGroupsContext";

const GroupsSection = ({ contacts, setContacts }) => {
  const {
    groups,
    fetchGroups,
    createGroup,
    addContactsToGroup,
    listGroupContacts,
  } = useContactGroups();

  const [showAddGroup, setShowAddGroup] = useState(false);
  const [assigningGroupId, setAssigningGroupId] = useState(null);
  const [showAssignGroupModal, setShowAssignGroupModal] = useState(false);

  const [showContactsModal, setShowContactsModal] = useState(false);
  const [groupContacts, setGroupContacts] = useState([]);
  const [activeGroupName, setActiveGroupName] = useState("");
  const [activeGroupId, setActiveGroupId] = useState(null); // add this

  const handleShowContacts = async (group) => {
    try {
      const response = await listGroupContacts(group.id);
      setGroupContacts(response || []);
      setActiveGroupName(group.name);
      setActiveGroupId(group.id); // store groupId for remove
      setShowContactsModal(true);
    } catch (error) {
      toast.error("Failed to fetch group contacts");
    }
  };
  useEffect(() => {
    fetchGroups().catch(() => toast.error("Failed to load groups"));
  }, [fetchGroups]);

  const handleCreateGroup = async (newGroupData) => {
    try {
      await createGroup(newGroupData);
      await fetchGroups();
      toast.success("Group created successfully");
      setShowAddGroup(false);
    } catch (error) {
      toast.error("Failed to create group");
    }
  };

  return (
    <div className="w-full mt-8">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-white">
          Groups
        </h2>
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-5 py-2.5 rounded-lg shadow transition-colors"
          onClick={() => setShowAddGroup(true)}
        >
          + New Group
        </button>
      </div>

      {/* No Groups Message */}
      {groups.length === 0 ? (
        <div className="flex justify-center items-center h-48 bg-gray-50 dark:bg-gray-900 rounded-lg shadow-inner">
          <p className="text-gray-500 dark:text-gray-400 text-base">
            No groups yet. Click “+ New Group” to create one.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {groups.map((group) => (
            <div
              key={group.id}
              className="dark:bg-gray-800 p-6 bg-gray-100 rounded-2xl shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white truncate">
                  {group.name}
                </h3>
                <p className="text-sm text-blue-600 dark:text-blue-400 font-medium mt-1">
                  {group.contacts?.length || 0} contact(s)
                </p>
              </div>

              <div className="flex flex-wrap gap-3">
                <button
                  onClick={() => {
                    setAssigningGroupId(group.id);
                    setShowAssignGroupModal(true);
                  }}
                  className="flex-1 inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium py-2 px-4 rounded-lg transition"
                >
                  Assign
                </button>

                <button
                  onClick={() => handleShowContacts(group)}
                  className="flex-1 inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium py-2 px-4 rounded-lg transition"
                >
                  View
                </button>

                {/* Optional delete action */}
                {/* 
            <button
              onClick={() => toast.info("Delete functionality coming soon.")}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium py-2 px-4 rounded-lg transition"
            >
              <MdDelete size={18} />
              <span>Delete</span>
            </button> 
            */}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modals */}
      <CreateGroupModal
        isOpen={showAddGroup}
        onClose={() => setShowAddGroup(false)}
        onCreate={handleCreateGroup}
      />

      <AssignGroupModal
        isOpen={showAssignGroupModal}
        onClose={() => setShowAssignGroupModal(false)}
        groupId={assigningGroupId}
        contacts={contacts}
        setContacts={setContacts}
      />

      <GroupContactsModal
        isOpen={showContactsModal}
        onClose={() => setShowContactsModal(false)}
        groupContacts={groupContacts}
        groupName={activeGroupName}
        groupId={activeGroupId}
        refreshGroups={fetchGroups}
        refreshGroupContacts={async (gid) => {
          const refreshed = await listGroupContacts(gid);
          setGroupContacts(refreshed || []);
        }}
      />
    </div>
  );
};

export default GroupsSection;
